module.exports = __webpack_public_path__ + "static/media/ava.a100fc6a.jpg";